import '../../ieConfig/MobxConfig'
import { types } from 'mobx-state-tree'

const Autopay = types.model('Autopay', {
  si_flag: types.optional(types.string, ''),
  si_product_id: types.optional(types.string, ''),
  si_expiry_date: types.optional(types.string, ''),
  si_customer_id: types.optional(types.string, ''),
  si_frequency: types.optional(types.string, ''),
  si_product_desc: types.optional(types.string, ''),
  si_amount_type: types.optional(types.string, ''),
  si_max_amount: types.optional(types.string, ''),
  isAutoSipTxn: types.optional(types.string, ''),
})

export const Bill = types.model('Bill', {
  billid: types.optional(types.string, ''),
  billerid: types.optional(types.string, ''),
  billername: types.optional(types.string, ''),
  billdetail: types.optional(types.string, ''),
  autoPay: types.optional(Autopay, {}),
  authenticator1: types.optional(types.string, ''),
  authenticator2: types.optional(types.string, ''),
  authenticator3: types.optional(types.string, ''),
  authenticator4: types.optional(types.string, ''),
  authenticator5: types.optional(types.string, ''),
  authenticator6: types.optional(types.string, ''),
  authenticator7: types.optional(types.string, ''),
})
